// In production, we register a service worker to serve assets from local cache.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.

// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/),
);

export async function register(): Promise<void> {
  if (!('serviceWorker' in navigator)) {
    return;
  }

  // Previously this was disabled for development,
  // but it's needed for push notifications to work
  // so I'm re-enabling it until it proves to be problematic
  // 2026-04-10

  // Only register service worker in production
  // if (import.meta.env.MODE !== 'production') {
  //   return;
  // }

  if ('serviceWorker' in navigator) {
    // The URL constructor is available in all browsers that support SW.
    const publicUrlString = import.meta.env.PUBLIC_URL || '';
    const publicUrl = new URL(publicUrlString, window.location.href);

    if (publicUrl.origin !== window.location.origin) {
      // Our service worker won't work if PUBLIC_URL is on a different origin
      // from what our page is served on. This might happen if a CDN is used to
      // serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
      return;
    }
  }

  // Notify the service worker when this tab is closing so it can wipe the
  // PHI S3 media cache if no other tabs remain open.
  window.addEventListener('pagehide', () => {
    if (navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage({ type: 'TAB_CLOSING' });
    }
  });

  window.addEventListener('load', () => {
    const publicUrl = import.meta.env.PUBLIC_URL || '';
    // Use firebase-messaging-sw.js for Chrome compatibility
    const swUrl = `${publicUrl}/firebase-messaging-sw.js`;
    if (isLocalhost) {
      // This is running on localhost. Lets check if a service worker still exists or not.
      registerValidSW(swUrl);

      // Add some additional logging to localhost, pointing developers to the
      // service worker/PWA documentation.
      navigator.serviceWorker.ready.then(() => {
        console.log(
          'This web app is being served cache-first by a service ' +
            'worker. To learn more, visit https://goo.gl/SC7cgQ',
        );
      });
    } else {
      // Is not local host. Just register service worker
      registerValidSW(swUrl);
    }
  });
}

function registerValidSW(swUrl: string): void {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration: ServiceWorkerRegistration) => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker) {
          installingWorker.onstatechange = () => {
            if (installingWorker.state === 'installed') {
              if (navigator.serviceWorker.controller) {
                // At this point, the old content will have been purged and
                // the fresh content will have been added to the cache.
                // It's the perfect time to display a "New content is
                // available; please refresh." message in your web app.

                console.log('New content is available; please refresh.');
              } else {
                // At this point, everything has been precached.
                // It's the perfect time to display a
                // "Content is cached for offline use." message.

                console.log('Content is cached for offline use.');
              }
            }
          };
        }
      };
    })
    .catch((error: Error) => {
      console.error('Error during service worker registration:', error);
    });
}

export default function unregister(): void {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((registration: ServiceWorkerRegistration) => {
      registration.unregister();
    });
  }
}
